<div class="dash-MainGrid">
	<!--School Select-->
	<div class="dash-MenuBarItem">
		<h5 class="dash-InnerItem control-label MinorHeading">School</h5>
		<div>
			<caass-schoolselector [Disabled]="IsLoading()" [ShowAll]="false"> </caass-schoolselector>
		</div>

		<h5 class="dash-InnerItem control-label MinorHeading" style="margin-top: 10px">Facility</h5>
		<div>
			<select [disabled]="IsLoading() == true" class="form-control" name="FacilityID" [(ngModel)]="FacilityID">
				<option value="" style="display: none"></option>
				<option *ngFor="let o of lstFacility" [ngValue]="o.FacilityID">[{{ o.FacilityCD }}] - {{ o.FacilityName }}</option>
			</select>
		</div>

		<button [disabled]="IsLoading() == true" class="btn btn-primary TopMargin" (click)="onRefresh()">Refresh</button>
	</div>

	<!--Components-->
	<div class="dashboard-grid">
		<div class="dash-Item" *ngIf="LoadingPreference == false && FacilityID != undefined">
			<caass-ms-todays-snapshot [FacilityID]="FacilityID"> </caass-ms-todays-snapshot>
		</div>

		<div class="dash-Item" *ngIf="LoadingPreference == false && FacilityID != undefined">
			<caass-ms-station-status [FacilityID]="FacilityID"> </caass-ms-station-status>
		</div>

		<div class="dash-Item" *ngIf="LoadingPreference == false && FacilityID != undefined">
			<caass-ms-blocked-list-attempts [FacilityID]="FacilityID"> </caass-ms-blocked-list-attempts>
		</div>

		<div class="dash-Item" *ngIf="LoadingPreference == false && FacilityID != undefined">
			<caass-ms-waiting-for-verification [FacilityID]="FacilityID"> </caass-ms-waiting-for-verification>
		</div>

		<div class="dash-Item" *ngIf="LoadingPreference == false && FacilityID != undefined">
			<caass-ms-todays-visitees [FacilityID]="FacilityID"> </caass-ms-todays-visitees>
		</div>

		<div class="dash-Item" *ngIf="LoadingPreference == false && FacilityID != undefined">
			<caass-ms-todays-reasons [FacilityID]="FacilityID"> </caass-ms-todays-reasons>
		</div>

		<div class="dash-Item" *ngIf="LoadingPreference == false && FacilityID != undefined">
			<caass-ms-visitor-graph #Panel1 [FacilityID]="FacilityID" [GraphPanel]="Graph1OptionID"> </caass-ms-visitor-graph>
		</div>

		<div class="dash-Item" *ngIf="LoadingPreference == false && FacilityID != undefined">
			<caass-ms-visitor-graph #Panel2 [FacilityID]="FacilityID" [GraphPanel]="Graph2OptionID"> </caass-ms-visitor-graph>
		</div>
	</div>
</div>
